import React from 'react';
import {useState} from 'react';
import { Form, Button, Row, Col,message, Input, Select,DatePicker, Tooltip } from 'antd';
import { CONST_OUTS_UOM_OPTIONS } from '../../common/manageOutsConstants';
import { LeafIcon } from '../common/CustomerIcons';
import _ from 'lodash';
import { convertStorageCode } from './formattedSubsData'
import { SLASH_DATE_FORMAT } from '../../common/constants';
import moment from 'moment';

function ManageOutsProductCard(props) {
  const { product, index, onSubstitute, originalItemUom, isFromOuts, deliveryDate,isDragable=false, }= props;
  let initialValues = product;
  // const tooltipText = (initialValues.pricePerUuom && String(initialValues.pricePerUuom).trim()) 
  // ? `Price Per UUOM: $${initialValues.pricePerUuom}` 
  // : (initialValues.pricePerNetWeight && String(initialValues.pricePerNetWeight).trim()) 
  //   ? `Price Per Net Weight: $${initialValues.pricePerNetWeight}` 
  //   : 'NA';
  const tooltipText = (initialValues.pricePerNetWeight && String(initialValues.pricePerNetWeight).trim()) 
  ? `Price Per Net Weight: $${initialValues.pricePerNetWeight}` 
  : 'NA';
  const [expandedKey, setExpandedKey] = useState(null);

  const toggleText = key => {
    setExpandedKey(prev => (prev === key ? null : key));
  };

  const ExpandableText = ({ text, keyName, alignRight = false, tooltipTitle = '' }) => {
    const value = text ;
    const expanded = expandedKey === keyName;

    return (
      <div
        onClick={e => {
          e.stopPropagation();
          toggleText(keyName);
        }}
         title={expanded ? '' : tooltipTitle}
        style={{
          cursor: 'pointer',
          textAlign: alignRight ? 'right' : 'left',
          overflow: expanded ? 'visible' : 'hidden',
          textOverflow: expanded ? 'clip' : 'ellipsis',
          whiteSpace: expanded ? 'normal' : 'nowrap',
          wordBreak: expanded ? 'break-word' : 'normal',
          fontSize: expanded ? '12px' : 'inherit',
          lineHeight: expanded ? '16px' : 'inherit',
        }}
      >
        <CustomLabel itemValue={value} />
      </div>
    );
  };

  
  // let productUOM = initialValues.site_details[0].shipSplitsOnly ==='Y'? 'EA' : (initialValues.site_details[0].minimunSplit===0 ? 'CS' : 'CS-EA');

 
  let csAsoh;
  let eaAsoh;
  if(originalItemUom==='CS'){
    csAsoh=initialValues.asoh;
    eaAsoh=initialValues.secondAsoh;
  }
  else{
    csAsoh=initialValues.secondAsoh;
    eaAsoh=initialValues.asoh;
  }
  const csLong= String(csAsoh || '').length>4;
  const eaLong=String(eaAsoh || '').length>4;
  const CustomLabel = props => {
    const { suffix, prefix,itemValue } = props;
    let dataValue = itemValue;
    dataValue && suffix && (dataValue = `${dataValue}${suffix}`)
    dataValue && prefix && (dataValue = `${prefix}${dataValue}`)
    return (
      <label className="product-card-custom-form-item-value">{dataValue}</label>
    );
  }
  const onClick = () => {
    onSubstitute(product);
  }
  //moment.js bug? I am not sure...
  /*let currentDate = new Date();
  let year = currentDate.getFullYear();
  let month = currentDate.getMonth() + 1;
  let date = currentDate.getDate();
  if(month < 10) month = '0' + month;
  if(date < 10) date = '0' + date;
  let days = 0;
  //Create moment by year, month and day, instead of directly moment()
  let tempMoment = moment(`${year}${month}${date}`, 'YYYYMMDD')
  if(deliveryDate) {
    days = tempMoment.diff(moment(deliveryDate, 'MM/DD/YYYY'), 'days')
  }
  const startDate = tempMoment.subtract(days, 'day')
  const disablePastDt = current => {
    return current.isBefore(startDate);
  };*/
  const yesterday = moment().subtract(0, 'day');
  const disablePastDt = current => {
    return current.isBefore(yesterday);
  };
  // const uom = getUom(initialValues.site_details[0])
  let itemInfo = `${initialValues.site_details[0].originalItemUom} | ${initialValues.pack}/${initialValues.size} | ${convertStorageCode(initialValues.site_details[0].storageCode)} | ${initialValues.sysco_brand}`
  return (
  //  <div className={`manage-subs-manage-outs-product-card${isDragable ? ' dragable-product-card' : ''}`} id={index}>
 <div className={`manage-subs-manage-outs-product-card ${isDragable?' dragable-product-card':''}`} id={index}>
  {!isDragable && <>
      <Row gutter={[4, 2]} justify="space-between" >
        <Col span={12}>
          <Form.Item className='product-card-value' name={`subItem_${index}`} style={{marginTop:'3px', fontSize:'17px'}}>
            {initialValues.supc}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item colon={false} className="item-no-of-subbed" label="No. of times subbed" name={`noOfSubbed_${index}`}
            style={{fontSize:'17px'}}>
            {initialValues.frequency}
          </Form.Item>
        </Col>
      </Row>
      {/* <Row gutter={[4, 2]} justify="space-between">
        <Col span={24}>
          <Form.Item className="product-card-static-form-item-value" name="item_description" >
         
            <CustomLabel suffix=' ' itemValue={initialValues.item_description}/>
          </Form.Item>
        </Col>
      </Row> */}
        <Row gutter={[4, 2]} justify="space-between">
          <Col span={15}>
            <Form.Item className="product-card-static-form-item-value" name="item_description" style={{ marginBottom: 0 }}>
              {/* <ExpandableText text={initialValues.item_description} keyName="nonDragItemDesc" /> */}
              <span title={initialValues.item_description} style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} >
                 <CustomLabel itemValue={initialValues.item_description} /> 
                 </span>
            </Form.Item>
          </Col>
          <Col span={9}>
            <Form.Item className="product-card-static-form-item-value" name="UuomOrNetWeight" style={{ marginBottom: '8px', textAlign: 'left', marginLeft:'2px' }}>
              <Tooltip title={tooltipText}>
                <span style={{ display: 'block', textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}>
                  <CustomLabel itemValue={initialValues.UuomOrNetWeight ? ` $${initialValues.UuomOrNetWeight}` : 'NA'} />
                </span>
              </Tooltip>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[8, 2]} justify="space-between">
        <Col span={15} style={{maxHeight:'22px'}}>
          <div className="flex align-items-center series-tips-content-items-2">
            <Form.Item className="product-card-static-form-item-value">
              {/* <span style={{'whiteSpace':'normal'}} title={itemInfo} >{itemInfo}</span> */}
              <div style={{'whiteSpace':'normal'}}>
                <span title={itemInfo} style={{fontSize:15,fontWeight:700,color:'#0071bc'}}>{initialValues.site_details[0].originalItemUom}</span>
                <span style={{fontSize:15}}> | </span>
                <span title={itemInfo} style={{fontSize:15,fontWeight:700,color:'#0071bc'}}>{initialValues.pack}/{initialValues.size}</span>
                <span> | {convertStorageCode(initialValues.site_details[0].storageCode)} | {initialValues.sysco_brand}</span>
              </div>
            </Form.Item>
            
            {/* <Form.Item className="product-card-static-form-item-value" name="subUom">
              <CustomLabel suffix=' | ' itemValue={initialValues.subUom}/>
            </Form.Item>
            <Form.Item className="product-card-static-form-item-value" name="subPack">
              <CustomLabel suffix='/' itemValue={initialValues.subPack}/>
            </Form.Item>
            <Form.Item  className="product-card-static-form-item-value" name="subSize">
              <CustomLabel suffix=' | ' itemValue={initialValues.subSize}/>
            </Form.Item>
            <Form.Item  className="product-card-static-form-item-value" name="subStorageCode">
              <CustomLabel suffix=' | ' itemValue={initialValues.subStorageCode}/>
            </Form.Item>
            <Form.Item  className="product-card-static-form-item-value" name="subBrand">
              {initialValues.subBrand}
            </Form.Item> */}
          </div>
        </Col>
        
        <Col span={9}>
          {/* <Row style={{marginLeft:initialValues.site_details[0].originalItemUom==='CS-EA'?'-14px':'0px'}}> */}
          <Row style={{marginLeft: 0}}>
            {/* <Col span={6} className="product-card-static-col" style={{marginTop: initialValues.site_details[0].originalItemUom === 'CS-EA' ? 0 : '-14px'}}> */}
            <Col span={6} className="product-card-static-col" style={{marginTop: '-16px'}}>
              <Form.Item colon={false} className="product-card-static-form-item-value-1 aosh" label="ASOH" name="asoh">
              </Form.Item>
            </Col>
            {initialValues.site_details[0].originalItemUom === 'CS' && (
              <Col span={18}>
                <Row>
                  <Col className="product-card-static-col" style={{marginTop:'-16px'}}>
                    <Form.Item className="item-quantity product-card-value" name="asoh">
                      {csAsoh}
                    </Form.Item>
                  </Col>
                  <Col className="product-card-static-col" style={{marginTop:'-16px', marginLeft:'1px'}}>
                    <Form.Item colon={false} className="product-card-static-form-item-value-1 label-left" label="CS">
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            )}
            {initialValues.site_details[0].originalItemUom === 'EA' && (
              <Col span={18}>
                <Row>
                  <Col className="product-card-static-col" style={{marginTop:'-16px'}}>
                    <Form.Item className="item-quantity product-card-value" name="asoh">
                      {eaAsoh}
                    </Form.Item>
                  </Col>
                  <Col className="product-card-static-col" style={{marginTop:'-16px', marginLeft:'1px'}}>
                    <Form.Item colon={false} className="product-card-static-form-item-value-1 label-left" label="EA">
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            )}
            {initialValues.site_details[0].originalItemUom === 'CS-EA' && (
                <Col span={18}>
                  <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                      marginTop: '-16px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <Tooltip title={csAsoh}>
                    <span
                      style={{
                          display: 'inline-block',
                          width: 34,
                          overflow: 'hidden',
                          marginLeft:'3px',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          color: '#0071bc',
                          fontWeight: 700,
                          // textAlign: 'right',
                          textAlign: 'center',
                        }}
                      >
                        {csAsoh}
                    </span>
                    </Tooltip>
                    <span style={{ margin: '0 4px', color: '#666' }}>CS</span>
                    <Tooltip title={eaAsoh}>
                  <span
                    style={{
                          display: 'inline-block',
                          width: 34,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          color: '#0071bc',
                          fontWeight: 700,
                          textAlign: 'right',
                        }}
                      >
                        {eaAsoh}
                    </span>
                    </Tooltip>
                    {/* <span style={{ marginLeft: 4, color: '#666' }}>EA</span> */}
                    <span style={{ marginLeft: 10, marginRight: '5px', color: '#666' }}>EA</span>
                  </div>
              </Col>
            )}
          </Row>  
            <Row style={{justifyContent:'start'}}>
              <Col className="product-card-static-col" style={{marginRight:initialValues.site_details[0].originalItemUom==='CS-EA'?originalItemUom==='EA'?'28px':'72px':'63px',marginLeft:'-18px'}}>
                <div
                  style={{display: 'flex',flexDirection:initialValues.price !== '---' &&initialValues.comparePrice !== '---'? 'column' : 'row',alignItems: 'flex-end',marginLeft: '18px',paddingTop: '4px',}}
                >
                  <Tooltip title="Market Price">
                    <span style={{ color: '#db930b', marginBottom: 2}}>
                      <CustomLabel
                        prefix={initialValues.price === '---' ? ' ' : ' $'}
                        itemValue={initialValues.price === '---' ? 'Market Price' : initialValues.price}
                      />
                    </span>
                  </Tooltip>
                  <Tooltip title="Compare Price">
                    <span
                      style={{
                        color: '#666666',
                        marginLeft:initialValues.price === '---' ||initialValues.comparePrice === '---'? 6: 0,
                        marginTop:initialValues.price !== '---' && initialValues.comparePrice !== '---' ? 6:0,
                    }}
                    >
                      <CustomLabel 
                      //COT-5367,when the price fetch is failed, add a ‘Market Price’ label in place of the price
                        prefix={initialValues.comparePrice === '---'?' ':' $'}
                        itemValue={initialValues.comparePrice === '---'?'':initialValues.comparePrice}
                      />
                    </span>
                  </Tooltip>
                </div>
              </Col>
            </Row>
          </Col>
          {/* <Col span={5}>
          <Row>
            <Col className="product-card-static-col">
              <Form.Item className="item-quantity product-card-value" name="splitQuantity">
                {initialValues.splitQuantity}
              </Form.Item>
            </Col>
            <Col className="product-card-static-col">
              <Form.Item colon={false} className="product-card-static-form-item-value-1 label-left" label="EA">
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col className="product-card-static-col">
              <div className="flex align-items-center">
                <Form.Item className="item-price" name="splitPrice">
                  <CustomLabel prefix=' $' itemValue={initialValues.splitPrice}/>
                </Form.Item>
              </div>
            </Col>
          </Row>
        </Col> */}
      </Row>
      <Row gutter={[8, 2]}>
      <Col span={6}>
        { initialValues.kosherItem==='Y' && (
               
              <div className='kosher-flag'>
              Kosher
            <span>K</span>
          </div>
            
            )}
        </Col> 
        <Col push={3}  style={{height:"36px"}} >
          {initialValues.site_details[0].is_sysco_brand && (
            <LeafIcon />
          )}
        </Col>
        
      </Row>
      </>}
      {isDragable && <>
      <Tooltip title="Drag product card to sub rule." placement="topLeft">
        <Row style={{maxHeight:'33px'}}>
          <Col span={6}>
            <Form.Item className='product-card-value' name={`subItem_${index}`} style={{ fontSize: '15px' }}>
              {initialValues.supc}
            </Form.Item>
          </Col>
          <Col span={7}>
            {initialValues.kosherItem === 'Y' && (
              <div className='kosher-flag'>
                Kosher
                <span>K</span>
              </div>
            )}
          </Col>
          <Col span={3} >
          {initialValues.site_details[0].is_sysco_brand && (
            <LeafIcon  style={{paddingTop: '5px'}}/>
          )}
            </Col>
            <Col className="product-card-static-col drag-item-price-col" style={{ marginRight: initialValues.site_details[0].originalItemUom === 'CS-EA' ? originalItemUom === 'EA' ? '3px' : '4px' : '5px', marginLeft: '0px', justifyContent: 'flex-end', paddingTop: 17 }}>
              <div className="flex align-items-center">
                <Form.Item className="item-price" name="price">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <Tooltip title="Market Price">
                      <span style={{
                        marginBottom: 1,
                        minHeight: 15,
                        minWidth: 30,
                        display: 'inline-block',
                        color: '#db930b', // orange for Market Price
                      }}>
                        <CustomLabel
                          prefix={initialValues.price === '---' || initialValues.price === null || initialValues.price === undefined || initialValues.price === '' || initialValues.price === 0 ? ' ' : ' $'}
                          itemValue={initialValues.price === '---' || initialValues.price === null || initialValues.price === undefined || initialValues.price === '' || initialValues.price === 0 ? 'Market Price' : initialValues.price}
                        />
                      </span>
                    </Tooltip>
                    <Tooltip title="Compare Price">
                      <span style={{
                        minHeight: 15,
                        fontSize:13,
                        minWidth: 30,
                        display: 'inline-block',
                        color: '#666666',
                      }}>
                        <CustomLabel 
                        //COT-5367,when the price fetch is failed, add a ‘Market Price’ label in place of the price
                          prefix={initialValues.comparePrice === '---'?' ':' $'}
                          itemValue={initialValues.comparePrice === '---' ? '' : initialValues.comparePrice}
                        />
                      </span>
                    </Tooltip>
                  </div>
                </Form.Item>
              </div>
            </Col>
          </Row>
          {/* <Row gutter={[4, 1]} justify="space-between" style={{ maxHeight: '40px' }}>
            <Col span={24}>
              <Form.Item className="product-card-static-form-item-value" name="item_description" >
                <CustomLabel suffix=' ' itemValue={initialValues.item_description} />
             </Form.Item>
            </Col>
          </Row> */}

          <Row gutter={[4, 1]} justify="space-between" style={{ maxHeight: '40px' }}>
            <Col span={16}>
              <Form.Item
                className="product-card-static-form-item-value"
                name="item_description"
                style={{ marginBottom: 0 }}
              >
                {/* <ExpandableText text={initialValues.item_description} keyName="dragItemDesc" /> */}
                <span title={initialValues.item_description} style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} > 
                  <CustomLabel itemValue={initialValues.item_description} /> 
                </span>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item className="product-card-static-form-item-value" name="UuomOrNetWeight" style={{ marginBottom: '8px', textAlign: 'right' }}>
                <Tooltip title={tooltipText}>
                  <span style={{ display: 'block', textAlign: 'right', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}>
                    <CustomLabel itemValue={initialValues.UuomOrNetWeight ? ` $${initialValues.UuomOrNetWeight}` : 'NA'} />
                  </span>
                </Tooltip>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[8, 1]} justify="space-between">
            <Col style={{ maxHeight: '22px', width: '100%' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                {/* Item info with fixed width and ellipsis */}
                <div
                  style={{
                    width: '180px',
                    minWidth: '180px',
                    maxWidth: '180px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <span title={itemInfo} style={{ fontSize: 15, fontWeight: 700, color: '#0071bc' }}>
                    {initialValues.site_details[0].originalItemUom}
                  </span>
                  <span style={{ fontSize: 15 }}> | </span>
                  <span title={itemInfo} style={{ fontSize: 15, fontWeight: 700, color: '#0071bc' }}>
                    {initialValues.pack}/{initialValues.size}
                  </span>
                  <span> | {convertStorageCode(initialValues.site_details[0].storageCode)}</span>
                </div>
                {/* Sub button always at right with gap */}
                {isDragable && (
                  <div style={{ marginLeft: 'auto', paddingRight: '8px' }}>
                    <Form.Item style={{ margin: 0 }}>
                      <Button
                        type="primary"
                        onClick={() => {
                          if (props.form) {
                            let formData = props.form.getFieldsValue() || {};
                            let subRows = Array.isArray(formData.expandedSubItems) ? [...formData.expandedSubItems] : [];
                            while (subRows.length < 4) {
                              subRows.push({});
                            }
                            const emptyIndex = subRows.findIndex(
                              row => !row.substituteItem || String(row.substituteItem).trim() === ''
                            );
                            if (emptyIndex === -1) {
                              message.warning('All 4 Sub rows are filled. Please clear a row before adding.');
                              return;
                            }
                            const subRatio = props.form.getFieldValue(`subRatio_${emptyIndex}`);
                            const endDate = props.form.getFieldValue(`endDate_${emptyIndex}`);
                            props.onSubstitute(props.product, 'expandedSubItems', emptyIndex, subRatio, endDate);
                          } else {
                            props.onSubstitute(props.product);
                          }
                        }}
                        className="primary-btn"
                        style={{
                          fontSize: '14px',
                          height: '20px',
                          padding: '0 4px',
                          lineHeight: '20px',
                          boxSizing: 'border-box',
                          marginTop: '-2px',
                        }}
                      >
                        <div style={{ fontSize: '14px' }}>Sub</div>
                      </Button>
                    </Form.Item>
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col span={11}>
            <Form.Item className='product-card-static-form-item-value'>
              <div style={{ 'whiteSpace': 'normal' }}>
                  {/* <span>{initialValues?.sysco_brand}</span> </div> */}
                  <span
                    title={initialValues?.sysco_brand}
                    style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                  >
                    {initialValues?.sysco_brand}
                  </span> </div>
            </Form.Item>  </Col>
          <Col span={11}>
            <Form.Item colon={false} className="item-no-of-subbed" label="Sub Freq" name={`noOfSubbed_${index}`}
              style={{ fontSize: '13px' ,paddingRight:'5px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
              <span title={`${initialValues.frequency}`} >{initialValues.frequency}</span>
            </Form.Item>
          </Col></Row> 
          <Row gutter={8} style={{marginLeft:initialValues.site_details[0].originalItemUom==='CS-EA'?'0px':'0px'}}>
            <Col span={5} className="product-card-static-col" style={{marginTop:'-14px'}}>
              <Form.Item colon={false} className="product-card-static-form-item-value-1 aosh" label="ASOH" name="asoh">
              </Form.Item>
            </Col> 
            {initialValues.site_details[0].originalItemUom === 'CS' && (
              <Col span={17}>
                <Row>
                  <Col className="product-card-static-col" style={{marginTop:'-14px'}}>
                    <Form.Item className="item-quantity product-card-value" name="asoh">
                      {csAsoh}
                    </Form.Item>
                  </Col>
                  <Col className="product-card-static-col" style={{marginTop:'-16px', marginLeft:'1px'}}>
                    <Form.Item colon={false} className="product-card-static-form-item-value-1 label-left" label="CS">
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            )}
            {initialValues.site_details[0].originalItemUom === 'EA' && (
              <Col span={17}>
                <Row>
                  <Col className="product-card-static-col" style={{marginTop:'-14px'}}>
                    <Form.Item className="item-quantity product-card-value" name="asoh">
                      {eaAsoh}
                    </Form.Item>
                  </Col>
                  <Col className="product-card-static-col" style={{marginTop:'-16px', marginLeft:'1px'}}>
                    <Form.Item colon={false} className="product-card-static-form-item-value-1 label-left" label="EA">
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            )}
            {initialValues.site_details[0].originalItemUom === 'CS-EA' && (
              <Col span={17}>
                <Row>
                  <Col className="product-card-static-col" style={{marginTop:'-14px'}}>
                    <Form.Item className="item-quantity product-card-value" name="asoh">
                      {csAsoh}
                    </Form.Item>
                  </Col>
                  <Col className="product-card-static-col" style={{marginTop:'-16px', marginLeft:'1px'}}>
                    <Form.Item colon={false} className="product-card-static-form-item-value-1 label-left" label='CS'>
                    </Form.Item>
                  </Col>
                  <Col className="product-card-static-col" style={{marginTop:'-14px',marginLeft:'-5px'}}>
                    <Form.Item className="item-quantity product-card-value" name="asoh">
                      {eaAsoh}
                    </Form.Item>
                  </Col>
                  <Col className="product-card-static-col" style={{marginTop:'-16px', marginLeft:'1px',marginRight:'-10px'}}>
                    <Form.Item colon={false} className="product-card-static-form-item-value-1 label-left" label='EA'>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>     </Tooltip>
      </>}
      {/* {isFromOuts && ( */}
        <div className="flex" style={{marginBottom: isDragable?'0px':'10px'}}>
          <Row gutter={[16, 1]} justify="space-between" >
            <Col span={5}>
              <Form.Item name={`subRatio_${index}`}>
                <Input placeholder="Sub Ratio" defaultValue='1.00'></Input>
              </Form.Item>
            </Col>
            <Col span={isDragable?10:8}>
              <Form.Item name={`endDate_${index}`}>
                <DatePicker placeholder="End Date" format={SLASH_DATE_FORMAT} disabledDate={disablePastDt} />
              </Form.Item>
            </Col>
            <Col span={isDragable?7:5}>
              <Form.Item name={`uom_${index}`}>
                <Select placeholder="UOM" disabled={true} defaultValue={originalItemUom}>
                  {CONST_OUTS_UOM_OPTIONS.map(item => {
                    return (
                      <Select.Option key={item.key} value={item.key}>
                        {item.label}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
            {!isDragable && 
              <Form.Item>
                <Button type="primary" onClick={onClick} className="primary-btn">
                  <span style={{fontSize:'12px',width:'60px'}}>Substitute</span>
                </Button>
              </Form.Item>}
            </Col>
          </Row>
        </div>
      {/* )} */}
      {/* {!isFromOuts && (
        <Row>
          <Col offset={18} span={6}>
            <Form.Item>
              <Button type="primary" onClick={onClick} className="primary-btn">
                Substitute
              </Button>
            </Form.Item>
          </Col>
        </Row>
      )} */}
    </div>
  );
};

function areEqual(prevProps, nextProps) {
  return _.isEqual(prevProps.product, nextProps.product)
};

ManageOutsProductCard.propTypes = {};
ManageOutsProductCard.defaultProps = {};
export default React.memo(ManageOutsProductCard, areEqual)